// CADtomie compass / divider glyph — geometry mirrors the Intraop brand mark
// (apex pivot dot + two legs). Kept identical so the gait module reads as part
// of the CADtomie family.

interface Props {
  size?: number;
  stroke?: string;
  glow?: boolean;
}

export function BrandGlyph({ size = 30, stroke = "url(#cadg)", glow = true }: Props) {
  const apexX = size * 0.5;
  const apexY = size * 0.2;
  const leftX = size * 0.27;
  const rightX = size * 0.73;
  const baseY = size * 0.86;
  const sw = Math.max(2, size * 0.13);
  return (
    <svg
      width={size}
      height={size}
      viewBox={`0 0 ${size} ${size}`}
      style={{ display: "block", filter: glow ? "drop-shadow(0 2px 8px rgba(10,132,255,0.5))" : "none" }}
      aria-hidden="true"
    >
      <defs>
        <linearGradient id="cadg" x1="0" y1="0" x2="1" y2="1">
          <stop offset="0%" stopColor="#7cc4ff" />
          <stop offset="100%" stopColor="#5eead4" />
        </linearGradient>
      </defs>
      <line x1={leftX} y1={baseY} x2={apexX} y2={apexY} stroke={stroke} strokeWidth={sw} strokeLinecap="round" />
      <line x1={rightX} y1={baseY} x2={apexX} y2={apexY} stroke={stroke} strokeWidth={sw} strokeLinecap="round" />
      <circle cx={apexX} cy={apexY} r={sw * 0.9} fill={stroke} />
    </svg>
  );
}
